import { ml, modeId } from '../lib/profiles';
import { createPortal } from 'react-dom';
import { FileImage, PenLine, Clock, Satellite } from 'lucide-react';
import { openFloorPlans } from './FloorPlans';
import { openSketch } from './SketchEditor';
import { openRoofFrame } from './RoofFrame';
import { portalRoot } from './TourGuide';

// in-house: right after project / report creation the building gets its plan (upload or own sketch)
export default function PlanStart({ t, project, updateProject }) {
  if ((project.plans || []).length || project.planAsk) return null;
  const go = (fn) => { updateProject((p) => ({ ...p, planAsk: true })); fn?.(); };
  return createPortal(
    <div className="editor-backdrop" data-testid="plan-start-dialog">
      <div className="editor ps-card">
        <h4 className="ps-title">{t.plsTitle}</h4>
        <p className="muted">{ml(t, 'psIntro')}</p>
        <button className="ps-opt" data-testid="plan-start-upload" onClick={() => go(openFloorPlans)}><FileImage size={26} /><span><b>{t.psUpload}</b><small>{ml(t, 'psUploadD')}</small></span></button>
        <button className="ps-opt" data-testid="plan-start-sketch" onClick={() => go(() => openSketch())}><PenLine size={26} /><span><b>{t.psSketch}</b><small>{ml(t, 'psSketchD')}</small></span></button>
        {modeId() === 'detect_roof' && <button className="ps-opt" data-testid="plan-start-roof-frame" onClick={() => go(openRoofFrame)}><Satellite size={26} /><span><b>{t.rfBtn}</b><small>{t.rfHint}</small></span></button>}
        <button className="btn btn-outline btn-sm" data-testid="plan-start-later" onClick={() => go()}><Clock size={14} /> {t.psLater}</button>
      </div>
    </div>,
    portalRoot(),
  );
}
